import { useState, useEffect } from 'react'
import { apiFetch } from '../services/api'
import { useAuth } from '../context/AuthContext'

const CAMPOS_LABEL = {
  nombre: 'Nombre', codigo: 'Código', descripcion: 'Descripción',
  precio_compra: 'Precio Compra', precio_venta: 'Precio Venta',
  stock_actual: 'Stock Actual', stock_minimo: 'Stock Mínimo', activo: 'Estado',
}

const ACCIONES_LABEL = {
  cambio_permiso: 'Cambio de permiso',
  usuario_activado: 'Usuario activado',
  usuario_desactivado: 'Usuario desactivado',
  usuario_creado: 'Usuario creado',
  rol_cambiado: 'Rol cambiado',
  permisos_reseteados: 'Permisos reseteados',
}

export default function Auditoria() {
  const { perfil } = useAuth()
  const [tab, setTab] = useState('inventario')
  const [registros, setRegistros] = useState([])
  const [registrosPersonal, setRegistrosPersonal] = useState([])
  const [loading, setLoading] = useState(true)
  const [filtros, setFiltros] = useState({ producto: '', usuario: '', campo: '', fechaDesde: '', fechaHasta: '' })
  const [filtrosP, setFiltrosP] = useState({ usuario: '', afectado: '', accion: '', fechaDesde: '', fechaHasta: '' })

  useEffect(() => {
    cargarAuditoria()
    cargarAuditoriaPersonal()
  }, [perfil])

  const cargarAuditoria = async () => {
    setLoading(true)
    try {
      const data = await apiFetch('/auditoria/inventario')
      if (Array.isArray(data)) {
        setRegistros(data)
      } else {
        setRegistros([])
      }
    } catch (err) {
      console.warn('No se pudieron obtener registros de auditoría de inventario:', err)
      setRegistros([])
    } finally {
      setLoading(false)
    }
  }

  const cargarAuditoriaPersonal = async () => {
    try {
      const data = await apiFetch('/auditoria/personal')
      if (Array.isArray(data)) {
        setRegistrosPersonal(data)
      } else {
        setRegistrosPersonal([])
      }
    } catch (err) {
      console.warn('No se pudieron obtener registros de auditoría de personal:', err)
      setRegistrosPersonal([])
    }
  }

  const registrosFiltrados = registros.filter(r => {
    if (filtros.producto) {
      const term = filtros.producto.toLowerCase()
      if (!r.productos?.nombre?.toLowerCase().includes(term) &&
          !r.productos?.codigo?.toLowerCase().includes(term)) return false
    }
    if (filtros.usuario && !r.perfiles?.nombre?.toLowerCase().includes(filtros.usuario.toLowerCase())) return false
    if (filtros.campo && r.campo !== filtros.campo) return false
    if (filtros.fechaDesde && new Date(r.created_at) < new Date(filtros.fechaDesde + 'T00:00:00')) return false
    if (filtros.fechaHasta && new Date(r.created_at) > new Date(filtros.fechaHasta + 'T23:59:59')) return false
    return true
  })

  const registrosPersonalFiltrados = registrosPersonal.filter(r => {
    if (filtrosP.usuario && !r.perfil_nombre?.toLowerCase().includes(filtrosP.usuario.toLowerCase())) return false
    if (filtrosP.afectado && !r.afectado_nombre?.toLowerCase().includes(filtrosP.afectado.toLowerCase())) return false
    if (filtrosP.accion && r.accion !== filtrosP.accion) return false
    if (filtrosP.fechaDesde && new Date(r.created_at) < new Date(filtrosP.fechaDesde + 'T00:00:00')) return false
    if (filtrosP.fechaHasta && new Date(r.created_at) > new Date(filtrosP.fechaHasta + 'T23:59:59')) return false
    return true
  })

  const formatearFecha = (f) =>
    new Date(f).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })

  const renderDetalle = (r) => {
    if (!r.detalle) return '—'
    if (r.accion === 'cambio_permiso') {
      const antes = r.detalle.antes ? 'activo' : 'inactivo'
      const despues = r.detalle.despues ? 'activo' : 'inactivo'
      return `${r.detalle.permiso}: ${antes} → ${despues}`
    }
    if (r.accion === 'rol_cambiado') return `${r.detalle.antes} → ${r.detalle.despues}`
    if (r.accion === 'permisos_reseteados') return `Rol base: ${r.detalle.rol}`
    return typeof r.detalle === 'object' ? JSON.stringify(r.detalle) : r.detalle
  }

  if (loading) return (
    <div className="main-content">
      <div className="page-header"><h1 className="page-title">Auditoría</h1></div>
      <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>Cargando registros...</div>
    </div>
  )

  return (
    <div className="main-content">
      <div className="page-header">
        <h1 className="page-title">Auditoría</h1>
        <p className="page-subtitle">Registro de cambios del sistema</p>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', marginBottom: '1.5rem', borderBottom: '2px solid var(--border, #e2e8f0)' }}>
        {[
          { key: 'inventario', label: '📦 Inventario / Ventas' },
          { key: 'personal', label: '👥 Personal' },
        ].map(t => (
          <button key={t.key} type="button" onClick={() => setTab(t.key)} style={{
            padding: '0.75rem 1.5rem', border: 'none', cursor: 'pointer', fontWeight: '600',
            fontSize: '0.95rem', background: 'transparent', transition: 'all 0.2s',
            borderBottom: tab === t.key ? '2px solid var(--primary, #2563eb)' : '2px solid transparent',
            color: tab === t.key ? 'var(--primary, #2563eb)' : 'var(--text-light, #64748b)',
            marginBottom: '-2px',
          }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'inventario' && (
        <>
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem', alignItems: 'end' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Producto</label>
                <input className="form-input" type="text" placeholder="Nombre o código..."
                  value={filtros.producto} onChange={e => setFiltros(f => ({ ...f, producto: e.target.value }))} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Usuario</label>
                <input className="form-input" type="text" placeholder="Nombre..."
                  value={filtros.usuario} onChange={e => setFiltros(f => ({ ...f, usuario: e.target.value }))} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Campo</label>
                <select className="form-input" value={filtros.campo} onChange={e => setFiltros(f => ({ ...f, campo: e.target.value }))}>
                  <option value="">Todos</option>
                  {Object.entries(CAMPOS_LABEL).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Desde</label>
                <input className="form-input" type="date" value={filtros.fechaDesde} onChange={e => setFiltros(f => ({ ...f, fechaDesde: e.target.value }))} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Hasta</label>
                <input className="form-input" type="date" value={filtros.fechaHasta} onChange={e => setFiltros(f => ({ ...f, fechaHasta: e.target.value }))} />
              </div>
              <div>
                <button className="btn btn-outline" onClick={() => setFiltros({ producto: '', usuario: '', campo: '', fechaDesde: '', fechaHasta: '' })} style={{ width: '100%' }}>
                  Limpiar
                </button>
              </div>
            </div>
            <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid var(--border, #e2e8f0)', fontSize: '0.875rem', color: 'var(--text-light, #64748b)' }}>
              {registrosFiltrados.length} de {registros.length} registros
            </div>
          </div>

          <div className="card">
            <div className="table-container">
              <table>
                <thead>
                  <tr><th>Fecha</th><th>Usuario</th><th>Producto</th><th>Campo</th><th>Valor Anterior</th><th>Valor Nuevo</th></tr>
                </thead>
                <tbody>
                  {registrosFiltrados.length === 0 ? (
                    <tr><td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-light, #64748b)' }}>Sin registros de auditoría</td></tr>
                  ) : registrosFiltrados.map(r => (
                    <tr key={r.id}>
                      <td style={{ fontSize: '0.875rem', whiteSpace: 'nowrap' }}>{formatearFecha(r.created_at)}</td>
                      <td style={{ fontWeight: '500' }}>{r.perfiles?.nombre || 'Sistema'}</td>
                      <td>
                        <div style={{ fontWeight: '500' }}>{r.productos?.nombre || <span style={{ color: 'var(--text-light, #64748b)' }}>Eliminado</span>}</div>
                        {r.productos?.codigo && <div style={{ fontSize: '0.75rem', color: 'var(--text-light, #64748b)' }}>{r.productos.codigo}</div>}
                      </td>
                      <td><span style={{ padding: '0.2rem 0.5rem', background: '#f1f5f9', borderRadius: '4px', fontSize: '0.8rem', fontWeight: '600' }}>{CAMPOS_LABEL[r.campo] || r.campo}</span></td>
                      <td style={{ color: '#ef4444', fontSize: '0.875rem' }}>{r.valor_anterior || <span style={{ color: 'var(--text-light, #64748b)' }}>—</span>}</td>
                      <td style={{ color: '#10b981', fontWeight: '600', fontSize: '0.875rem' }}>{r.valor_nuevo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {tab === 'personal' && (
        <>
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem', alignItems: 'end' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Quién hizo el cambio</label>
                <input className="form-input" type="text" placeholder="Nombre..."
                  value={filtrosP.usuario} onChange={e => setFiltrosP(f => ({ ...f, usuario: e.target.value }))} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Afectado</label>
                <input className="form-input" type="text" placeholder="Nombre..."
                  value={filtrosP.afectado} onChange={e => setFiltrosP(f => ({ ...f, afectado: e.target.value }))} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Acción</label>
                <select className="form-input" value={filtrosP.accion} onChange={e => setFiltrosP(f => ({ ...f, accion: e.target.value }))}>
                  <option value="">Todas</option>
                  {Object.entries(ACCIONES_LABEL).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Desde</label>
                <input className="form-input" type="date" value={filtrosP.fechaDesde} onChange={e => setFiltrosP(f => ({ ...f, fechaDesde: e.target.value }))} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.4rem', color: 'var(--text-light, #64748b)' }}>Hasta</label>
                <input className="form-input" type="date" value={filtrosP.fechaHasta} onChange={e => setFiltrosP(f => ({ ...f, fechaHasta: e.target.value }))} />
              </div>
              <div>
                <button className="btn btn-outline" onClick={() => setFiltrosP({ usuario: '', afectado: '', accion: '', fechaDesde: '', fechaHasta: '' })} style={{ width: '100%' }}>
                  Limpiar
                </button>
              </div>
            </div>
            <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid var(--border, #e2e8f0)', fontSize: '0.875rem', color: 'var(--text-light, #64748b)' }}>
              {registrosPersonalFiltrados.length} de {registrosPersonal.length} registros
            </div>
          </div>

          <div className="card">
            <div className="table-container">
              <table>
                <thead>
                  <tr><th>Fecha</th><th>Quién</th><th>Afectado</th><th>Acción</th><th>Detalle</th></tr>
                </thead>
                <tbody>
                  {registrosPersonalFiltrados.length === 0 ? (
                    <tr><td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-light, #64748b)' }}>
                      Sin registros de cambios en personal
                    </td></tr>
                  ) : registrosPersonalFiltrados.map(r => (
                    <tr key={r.id}>
                      <td style={{ fontSize: '0.875rem', whiteSpace: 'nowrap' }}>{formatearFecha(r.created_at)}</td>
                      <td style={{ fontWeight: '500' }}>{r.perfil_nombre || '—'}</td>
                      <td>{r.afectado_nombre || '—'}</td>
                      <td>
                        <span style={{ padding: '0.2rem 0.6rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: '600', background: '#ede9fe', color: '#6d28d9' }}>
                          {ACCIONES_LABEL[r.accion] || r.accion}
                        </span>
                      </td>
                      <td style={{ fontSize: '0.875rem', color: 'var(--text-light, #64748b)' }}>{renderDetalle(r)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  )
}